<template>
  <main>
    <div class="container">
      <div class="row py-3 py-sm-5">
        <div class="col-12">
          <h1 class="text-white text-center">
            Create your Food Fitness First, Inc.® Account
          </h1>
        </div>
      </div>
    </div>

    <div class="container-fluid bg-white-trans py-3 mb-3 mb-sm-5">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h3 class="text-center">
              <strong>Individual</strong>
            </h3>
            <p class="lead text-center">
              <strong>Try free for 1 week! Check out all the benefits of your subscription below!</strong>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <notifications />
      <div class="row d-flex pb-3 pb-sm-5 justify-content-center">
        <div v-if="false" class="col-12 col-md-6 col-lg-6 d-flex align-items-stretch">
          <div class="card mb-3 w-100">
            <div class="card-header">
              <h4 class="card-title text-center m-0">
                Basic
              </h4>
            </div>
            <div class="card-body">
              <p><em>Limited access to exclusive posts and recipes and our Health Scorecard.</em></p>
              <ul>
                <li><strong class="text-red">Free!</strong></li>
                <li>Limited access to Blog Posts & Recipes</li>
                <li>Take the Full Health Assessment to be placed on a FOOD SPIRAL&reg;</li>
                <li>No Personal Health Resources/Handouts</li>
                <li>Partial access to premier features of the site like the Health Scorecard and Communications Panel</li>
              </ul>
            </div>
            <div class="card-footer text-center">
              <router-link
                :to="{name: 'register-free'}"
                class="btn btn-success btn-md"
              >
                Sign up
              </router-link>
            </div>
          </div>
        </div>
        <div
          class="col-12 col-md-6 col-lg-6 d-flex align-items-stretch"
        >
          <div class="card mb-3 w-100">
            <div class="card-header">
              <h4 class="card-title text-center m-0">
                Full
              </h4>
            </div>
            <div class="card-body">
              <p><em>Full access to Health Scorecard and personal health resources, as well as sample menus.</em></p>
              <ul>
                <li v-if="plans && plans.individual">
                  <strong class="text-red">${{ plans.individual.price }}</strong> per {{ plans.individual.interval }}
                </li>
                <li>Full access to Blog Posts & Recipes</li>
                <li>Take the Full Health Assessment to be placed on a FOOD SPIRAL&reg;</li>
                <li>Personal Health Resources/Handouts</li>
                <li>
                  <strong>Full access to the premier features of the site</strong>: Health Scorecard, Food Database, Food Tracker, Communications Panel, and Health Care Provider Share Portal.
                  <ul>
                    <li>Search the Color & Factor of thousands of foods</li>
                    <li>Recipe maker</li>
                    <li>Progress reports (visual charts and graphs that show color totals, food group percentages, daily factor reports...)</li>
                    <li>Secure portal that reports your health status and progress on your FOOD SPIRAL® to your Health Care Provider(s)</li>
                    <li>Direct communication from FFF</li>
                    <li>Health Assessment goal monitoring: Weight, step, fluid, sleep, and calorie needs</li>
                    <li>Daily tips & reminders that help reach health goals</li>
                    <li>And MUCH more!</li>
                  </ul>
                </li>
              </ul>
            </div>
            <div class="card-footer text-center">
              <router-link
                :to="{name: 'register-paid', params: {type: 'individual'}}"
                class="btn btn-success btn-md"
              >
                Sign up
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid bg-white-trans py-3">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center">
            <p><em>You may NOT make copies or share Food Fitness First, Inc.® registered information with outside sources. Our program memberships are for individual purchase only. Materials are copyrighted and violators will be prosecuted. </em></p>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Plans from '../services/plans.js';
export default {
  data() {
    return {
      plans: null
    }
  },
  mounted(){
    this.fetchPlans();
  },
  computed: {
    isCordova() {
      return this.$isCordova;
    }
  },
  methods:{
    fetchPlans(){
      Plans.get().then(res => {
        this.plans = res.data;
      }).catch(err => {
        this.plans = null;
      })
    }
  }
}
</script>
